// Sonner-based "Gmail-style" undo toast.
// After a destructive action, show a toast with an "Undo" button
// that restores the deleted item (via a caller-supplied restore fn)
// within `duration` ms (default 5s).
import { toast } from "sonner";

/**
 * @param {Object} opts
 * @param {string}   opts.message      Toast copy (e.g. "Dienst verwijderd").
 * @param {string}   opts.undoLabel    Action label (e.g. "Ongedaan maken").
 * @param {Function} opts.onUndo       async () => void — called when user hits undo.
 * @param {number}  [opts.duration=5000]
 * @param {string}  [opts.testid]      Optional data-testid prefix on the toast.
 */
export function toastWithUndo({ message, undoLabel = "Ongedaan maken", onUndo, duration = 5000, testid }) {
  // We guard against a stale double-click on Undo — only allow one call.
  let called = false;
  toast.success(message, {
    duration,
    action: {
      label: undoLabel,
      onClick: async () => {
        if (called) return;
        called = true;
        try {
          await onUndo?.();
          toast.success("Hersteld", { duration: 2500 });
        } catch (e) {
          toast.error("Kon niet herstellen");
        }
      },
    },
    ...(testid ? { className: `${testid}-toast` } : {}),
  });
}
